// Externals
import { createAction } from "@reduxjs/toolkit";
// Actions
export const initAnswers = createAction("INIT_ANSWERS");
export const updateAnswer = createAction("UPDATE_ANSWER");
export const updateInformation = createAction("UPDATE_INFORMATION");
